import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

declare var jQuery:any;
declare var $ :any;
declare var dialogCreate :any;
declare var dialogOpen :any;
declare var defaultChartExposureSettings;

@Component({
  selector: 'fund',
  templateUrl: './fund.component.html',
  styleUrls: ['./fund.component.css'],
})

export class FundBranch implements OnInit, OnDestroy {

  constructor (private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Currency and Funding Exposure");

    var mainNav = "exposure-nav";
var sideNav = "side-nav-risk-fund";

$(document).ready(function () {

  dialogCreate('#confirmFundNow', function() {
    jQuery.ajax({
      url: "/ajax/funding",
      type: 'PUT',
      success: (data, textStatus, jqXHR) => {
        if (jqXHR.status == 200) {
          var chart = jQuery('#exposureByPercentage').jqxChart('source');
          if (chart !== undefined) chart.dataBind();
          chart = jQuery('#exposureByCcyEquivalent').jqxChart('source');
          if (chart !== undefined) chart.dataBind();
        }
      }});
  });

  $("#fundNow").click(function() {
      dialogOpen('#confirmFundNow');
  });

  var chartDataRefresh = function (records) {
    $('#jqxExposureTabs').jqxTabs({ height: records.length*60 + 100 });
    $('#jqxExposureTabs').jqxTabs("refresh");
  };

        var initExposureByPercentage = function () {
      var source = {
        url : '/ajax/funding?sortBy=percentage&groupBy=currencyPair',
        type : 'GET',
        async : true
      };
    var settings = defaultChartExposureSettings('#exposureByPercentage', source, "Percentage", "Funded", true, chartDataRefresh);
    settings.showBorderLine=false;
            $('#exposureByPercentage').jqxChart(settings);
        };

        var initExposureByCcyEquivalent = function () {
      var source = {
          url : '/ajax/funding?sortBy=ccy&groupBy=currencyPair',
        type : 'GET',
        async : true
        };
        var settings = defaultChartExposureSettings('#exposureByCcyEquivalent', source, "BaseQuantity", "Funded", false, chartDataRefresh);
      settings.showBorderLine=false;
            $('#exposureByCcyEquivalent').jqxChart(settings);
        };

        var initExposureTabs = function (tab) {
            switch (tab) {
                case 0:
                  initExposureByPercentage();
                    break;
                case 1:
                  initExposureByCcyEquivalent();
                    break;
            }
        }

        $('#jqxExposureTabs').jqxTabs({ width: 750, height: 500, initTabContent: initExposureTabs });

});

/*]]>*/
  }
  ngOnDestroy() {
    $('#contentDiv').parent().remove();
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/exposure/fund/fund.component.ts